<template>
  <div>
    <div class="CheckBoxEntry-infos-container">
      <b-checkbox v-model="innerChecked" :disabled="disabled" @update:model-value="onCheckedChange">
        <div>
          {{ entryLabel }}
        </div>
      </b-checkbox>
      <div v-if="!hideExtrasUntilChecked || innerChecked" class="CheckBoxEntry-extras-container">
        <CheckBoxEntryInput
          v-if="extraInput1Placeholder"
          :entry-input-control="extraInput1Control"
          :entry-input-placeholder="extraInput1Placeholder"
          :entry-input-value="extraInput1Value"
          :disabled="disabled || !innerChecked"
          :vid="vid + '_input1'"
          :group="group"
          :rules="extraInput1Rule"
          :reset-input="resetInputs"
          @update:model-value="onInput1Change"
        />
        <CheckBoxEntryInput
          v-if="extraInput2Placeholder"
          :entry-input-control="extraInput2Control"
          :entry-input-placeholder="extraInput2Placeholder"
          :entry-input-value="extraInput2Value"
          :disabled="disabled || !innerChecked"
          :vid="vid + '_input2'"
          :group="group"
          :rules="extraInput2Rule"
          :reset-input="resetInputs"
          @update:model-value="onInput2Change"
        />
      </div>
    </div>
    <div v-if="entryInputPlaceholder">
      <CheckBoxEntryInput
        class="CheckBoxEntry-input"
        :name="entryLabel"
        :entry-input-placeholder="entryInputPlaceholder"
        :entry-input-value="entryInputValue"
        :disabled="disabled || !innerChecked"
        :group="group"
        :vid="vid"
        :reset-input="resetInputs"
        @update:model-value="onEntryInputChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import CheckBoxEntryInput from "./CheckBoxEntryInput.vue"
import { BCheckbox } from "buefy"

export default defineComponent({
  components: { BCheckbox, CheckBoxEntryInput },
  props: {
    vid: {
      type: String,
      default: "",
    },
    group: {
      type: String,
      default: "",
    },
    isChecked: {
      type: Boolean,
      default: false,
    },
    entryLabel: {
      type: String,
      default: "",
    },
    entryInputPlaceholder: {
      type: String,
      default: "",
    },
    entryInputValue: {
      type: String,
      default: "",
    },
    extraInput1Control: {
      type: String,
      default: "",
    },
    extraInput1Placeholder: {
      type: String,
      default: "",
    },
    extraInput1Value: {
      type: Number,
      default: 0,
    },
    extraInput1Rule: {
      type: String,
      default: "",
    },
    extraInput2Control: {
      type: String,
      default: "",
    },
    extraInput2Placeholder: {
      type: String,
      default: "",
    },
    extraInput2Value: {
      type: Number,
      default: 0,
    },
    extraInput2Rule: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideExtrasUntilChecked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["checked", "input-1", "input-2", "entry-input"],
  data() {
    return {
      entryInputType: "",
      innerChecked: false,
      resetInputs: false,
    }
  },
  watch: {
    innerChecked(): void {
      this.resetInputs = !this.innerChecked
    },
  },
  created(): void {
    this.innerChecked = this.isChecked
  },
  methods: {
    onCheckedChange(value: boolean): void {
      this.$emit("checked", value)
    },
    onInput1Change(value: any): void {
      this.$emit("input-1", value)
    },
    onInput2Change(value: any): void {
      this.$emit("input-2", value)
    },
    onEntryInputChange(value: any): void {
      this.$emit("entry-input", value)
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.CheckBoxEntry-input {
  margin-left: 0;

  .CheckBoxEntryInput {
    width: 100%;
  }

  .CheckBoxEntryInput-field {
    margin-bottom: 1rem;
    width: 100%;
  }
}

.CheckBoxEntry-infos-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $input-field-margin-bot;
}

.CheckBoxEntry-extras-container {
  display: flex;
  padding-top: 0.25rem;
}

#app [disabled].checkbox {
  color: $text-default-color;
}
</style>
